/* src/app/shared/authentication/components/forgot-password/forgot-password.component.scss */
/*# sourceMappingURL=forgot-password.component-R2T5HLVO.css.map */
